module.exports = __webpack_public_path__ + "static/img/weilingqu-1.97332de1.png";